/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IEditor } from "../../IEditor";
import { KEY_CODE } from "../../keyBinding/KeyCodeMap";
import { termsEditorViewEditor } from "../../terms/viewEditor";
import { CommonKeyCombinations } from "../../common/KeyCombinations";

export function registerCoreKeyBindings(dc: IEditor): void {
	const keyBindingSvc = dc.get("keyBindingService");

	// @todo translate
	keyBindingSvc.register({
		id: "resource.dialog.open",
		label: "Open Resource Dialog",
		commandId: "resource.dialog.open",
		keys: [
			{
				key: {
					ctrlKey: true,
					altKey: false,
					shiftKey: false,
					metaKey: false,
					keyCode: KEY_CODE.KEY_O
				},
				isWin: true,
				isLinux: true,
				isMac: false
			},
			{
				key: {
					ctrlKey: false,
					altKey: false,
					shiftKey: false,
					metaKey: true,
					keyCode: KEY_CODE.KEY_O
				},
				isWin: false,
				isLinux: false,
				isMac: true
			}
		]
	});

	keyBindingSvc.register({
		id: "view.save",
		label: termsEditorViewEditor.commands.saveResource,
		commandId: "view.save",
		keys: CommonKeyCombinations.save
	});
}
